const SYMBOLS = ["arrow_outward"] as const;

type SymbolType = (typeof SYMBOLS)[number];

export { SYMBOLS };
export type { SymbolType };
